export const SELECTION_MODE_ALL = 'SELECTION_MODE_ALL';
export const SELECTION_MODE_SINGLE = 'SELECTION_MODE_SINGLE';
export const SELECTION_MODE_MULTI = 'SELECTION_MODE_MULTI';
export const SELECT_UP = 'SELECT_UP';
export const SELECT_DOWN = 'SELECT_DOWN';
